import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Footer from '../Footer';
import { ContainerWrapper, Title, CardWrapper, CardsList } from './style';
import useCurrentLang from '@/hooks/useCurrentLang';
import { Link } from 'react-router-dom';
import useResize from '@/hooks/useResize';
import PATH from '@/router/path';
import { LoadingPage } from '@/layout';
import { sify } from 'chinese-conv/dist'
import { errorHandler } from '@/utils/toastHandler';
import { Helmet } from 'react-helmet';
import useGetFeatures from '@/hooks/useGetFeatures';
import LocalizedPageLinks from '@/components/SEO/LocalizedPageLinks';

const Features = () => {
  // @ts-ignore
  const { t } = useTranslation();
  const lang = useCurrentLang();
  const { isTablet, isMobile } = useResize();
  const [isLoading, setIsLoading] = useState(false);
  const features = useGetFeatures();
  const [data, setData] = useState<BannerFeature[]>([]);

  const initData = async () => {
    if(features.length === 0 ) return;
    setIsLoading(true);
    try {

      // 過濾show為1(允許在首頁出現)的值
      const filterFeatures = features.filter((feature) => feature.show === 1);

      // 按照weight排序, 0為最優先, 若weight相同則按照created_at排序
      const sortedFeatures = filterFeatures.sort((a, b) => {
        if (a.weight === b.weight) {
          return new Date(a.created_at).getTime() - new Date(b.created_at).getTime();
        }
        return b.weight - a.weight;
      });
      setData(sortedFeatures);
    } catch (error) {
      console.log(error);
      errorHandler(t('error.server'));
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    initData();
  }, [lang, features]);

  return (
    <>
      <Helmet>
        <title>{t('seo.features.title')}</title>
        <meta itemProp="name" content={t('seo.features.title')} />
        <meta property="og:title" content={t('seo.features.title')} />
        <meta name="twitter:title" content={t('seo.features.title')} />
        <meta name="description" content={t('seo.features.metaDescription')} />
        <meta property="og:description" content={t('seo.features.metaDescription')} />
        <meta name="twitter:description" content={t('seo.features.metaDescription')} />
      </Helmet>
      <LocalizedPageLinks pagePath="/features" />
      <LoadingPage isLoading={isLoading} />
      <ContainerWrapper>
        <Title>{t('pages.index.Features.title')}</Title>
        <CardsList isTablet={isTablet} isMobile={isMobile}>
          {data.map((feature) => (
            <CardWrapper key={feature.title + feature.title_en} isTablet={isTablet} isMobile={isMobile}>
              <div className="pic">
                <img src={feature.img_url} alt="" />
              </div>
              <div className="content">
                <h2>{lang === 'en' ? feature.title_en : lang === 'tc' ? feature.title : sify(feature.title)}</h2>
                <p>{lang === 'en' ? feature.description_en : lang === 'tc' ? feature.description : sify(feature.description)}</p>
                <Link to={PATH.features.detail.replace(':lang', lang).replace(':id', feature.cus_title)}>{t('buttons.howtoUse')}</Link>
              </div>
            </CardWrapper>
          ))}
        </CardsList>
      </ContainerWrapper>
      <Footer />
    </>
  );
};

export default Features;
